import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Feature Management - Combined Feature Showcase + Development Dashboard
 *
 * Admin-only page with tabs to switch between:
 * 1. Feature Showcase - Browse and select potential features
 * 2. Development Dashboard - Track current development progress
 */
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { PageContainer, PageTitle, Text } from '../../components/PageStyles';
import { Tabs } from '../../components/shared/Tabs';
import FeatureCatalog from './FeatureCatalog/FeatureCatalog';
import DevelopmentDashboard from './DevelopmentDashboard';
const FeatureManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'showcase');
    // Update URL when tab changes
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSearchParams({ tab: tabId });
        // Trigger reload of approved features when switching to catalog
        if (tabId === 'catalog') {
            window.dispatchEvent(new Event('focus'));
        }
    };
    // Sync with URL on mount
    useEffect(() => {
        const tabFromUrl = searchParams.get('tab');
        // Support both old 'showcase' and new 'catalog' param
        if (tabFromUrl === 'showcase' || tabFromUrl === 'catalog') {
            setActiveTab('catalog');
        }
        else if (tabFromUrl === 'dashboard') {
            setActiveTab('dashboard');
        }
    }, [searchParams]);
    return (_jsxs(PageContainer, { children: [_jsxs(Header, { children: [_jsx(PageTitle, { children: "Feature Management" }), _jsx(Text, { children: "Browse potential features and track development progress in one unified portal" })] }), _jsx(Tabs, { tabs: [
                    { id: 'catalog', label: 'Feature Catalog (106 Features)' },
                    { id: 'dashboard', label: 'Development Tracker' }
                ], activeTab: activeTab, onTabChange: handleTabChange }), _jsxs(TabContent, { children: [_jsx(ContentWrapper, { "$visible": activeTab === 'catalog' || activeTab === 'showcase', children: _jsx(FeatureCatalog, {}) }), _jsx(ContentWrapper, { "$visible": activeTab === 'dashboard', children: _jsx(DevelopmentDashboard, {}) })] })] }));
};
// Styled Components
const Header = styled.div `
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--border-color);

  p {
    margin-top: 12px;
  }
`;
const TabContent = styled.div `
  margin-top: 32px;
`;
const ContentWrapper = styled.div `
  display: ${props => props.$visible ? 'block' : 'none'};

  /* Strip PageContainer padding from nested components */
  > div {
    padding: 0;
    min-height: auto;
    max-width: none;
    margin: 0;
  }

  /* Hide duplicate titles from nested components */
  > div > h1:first-of-type,
  > div > p:first-of-type {
    display: none;
  }
`;
export default FeatureManagement;
